import { render, staticRenderFns } from "./GenericDataTable.vue?vue&type=template&id=2bf7949c&scoped=true&"
import script from "./GenericDataTable.vue?vue&type=script&lang=js&"
export * from "./GenericDataTable.vue?vue&type=script&lang=js&"
import style0 from "./GenericDataTable.vue?vue&type=style&index=0&id=2bf7949c&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf7949c",
  null
  
)

export default component.exports